import { auth } from '@frameio/utils';
import { ANONYMOUS_USER } from '@frameio/utils/auth/constants';
import { useMeCachedQuery } from './useMeCachedQuery';
/**
 * @returns currently authenticated userId
 */
export const useGetActiveUserId = () => {
  const userIdLocalStorage = auth.getUserId();
  const { data } = useMeCachedQuery();

  if (Boolean(userIdLocalStorage) && userIdLocalStorage !== ANONYMOUS_USER) {
    return userIdLocalStorage;
  }

  return data?.me?.id ?? ANONYMOUS_USER;
};
